module.exports = __webpack_public_path__ + "img/star-5.c35d80f4.svg";